import React from 'react';

export const ProjectDocumentsNoResults = () => (
  <div>No documents added</div>
);
